import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useMemo, useState } from 'react';
import { EyeIcon } from '../assets';
import Typography from '../typography/Typography';
import { Container, CustomCrossedEyeIcon, CustomErrorMessage, CustomInput, IconContainer, IconWrapper, Img, InputContainer, PlaceholderLabel, SendCodeText, Wrapper, PasswordIconButton, RightTextWrapper, } from './styles';
import { useInput } from './useInput';
const Input = forwardRef(({ loading, icon, value, testId, inputId, disabled, className, valid = true, placeholder, errorMessage, type = 'text', rightComponent, hasBorder = true, sendCode, errorTestId = 'input-error', onMouseEnter, onMouseLeave, onChangeText, onChange, onClick, onFocus, onBlur, inputMode, size = 'md', rightText, inputValuePlaceHolder, ...restProps }, ref) => {
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const { combinedRef, handleChange } = useInput({
        ref,
        disabled,
        onChange,
        onChangeText,
    });
    const handleClick = (e) => {
        e.stopPropagation();
        if (typeof onClick !== 'function' || disabled || !valid)
            return;
        onClick(e);
    };
    const handleVisibiltyChange = (e) => {
        if (disabled)
            return;
        e.stopPropagation();
        setIsPasswordVisible((prev) => !prev);
    };
    const isPasswordInput = useMemo(() => type === 'password', [type]);
    const inputType = useMemo(() => {
        if (!isPasswordInput)
            return type;
        return isPasswordVisible ? 'text' : 'password';
    }, [isPasswordInput, isPasswordVisible, type]);
    const handleFocus = (event) => {
        if (onFocus) {
            onFocus(event);
        }
        setIsFocused(true);
    };
    const handleBlur = (event) => {
        if (onBlur) {
            onBlur(event);
        }
        setIsFocused(false);
    };
    const handleWrapperClick = () => {
        if (disabled)
            return;
        combinedRef.current?.focus();
    };
    const hasIcon = typeof icon !== 'undefined';
    const iconComponent = typeof icon === 'string' ? _jsx(Img, { src: icon, alt: "input icon" }) : icon;
    const isInputFocused = isFocused || !!value || value === 0 || !!loading;
    return (_jsxs(Wrapper, { disabled: disabled, className: className, hasBorder: hasBorder, hasError: !!errorMessage, onClick: handleWrapperClick, size: size, children: [_jsxs(Container, { isPasswordInput: isPasswordInput, hasRightText: !!rightText, className: "container", children: [hasIcon && (_jsx(IconWrapper, { className: "icon-wrapper", children: iconComponent })), _jsxs(InputContainer, { className: "input-container", children: [placeholder && (_jsx(PlaceholderLabel, { className: "input-placeholder", type: "bodyButton", fontFamily: "primaryMedium", testId: "input-placeholder", isFocused: isInputFocused || !!inputValuePlaceHolder, children: placeholder })), _jsx(CustomInput, { value: value, inputMode: inputMode, type: inputType, "data-cy": testId, ref: combinedRef, disabled: disabled, "data-testid": testId, id: inputId || restProps.name, onMouseEnter: onMouseEnter, placeholder: inputValuePlaceHolder, onMouseLeave: onMouseLeave, onChange: handleChange, hasPlaceholder: !!placeholder, onFocus: handleFocus, onBlur: handleBlur, className: "common-input", ...restProps, isFocused: isInputFocused || !!inputValuePlaceHolder })] }), isPasswordInput && (_jsx(PasswordIconButton, { type: "button", "data-cy": "icon-container", onClick: handleVisibiltyChange, children: isPasswordVisible ? (_jsx(EyeIcon, { testId: "eye-icon" })) : (_jsx(CustomCrossedEyeIcon, { testId: "eye-crossed-icon" })) })), !rightComponent && sendCode && (_jsx(IconContainer, { className: "input-button", type: "button", onClick: handleClick, valid: valid, "data-testid": "sendCodeButton", children: _jsx(SendCodeText, { type: "caption", fontSize: 1.4, fontFamily: "primaryMedium", children: sendCode }) })), !!rightText && (_jsx(RightTextWrapper, { children: _jsx(Typography, { type: "subHeadline", fontFamily: "primaryBold", children: rightText }) })), rightComponent] }), _jsx(CustomErrorMessage, { errorTestId: errorTestId, errorMessage: errorMessage })] }));
});
Input.displayName = 'Input';
export default Input;
//# sourceMappingURL=Input.js.map